<template>
  <main class="welcome">
    <div class="info">
      <span v-if="isProUser" class="step">Step {{ currentStep }} of {{ totalSteps }}</span>
      <h1 class="title">Hello.</h1>
      <p class="intro">To get started we’ll need to import some of your store data. This should only take a minute.</p>

      <ul class="bars">
        <li class="bar">
          <ProgressBar :progress="productsProgress" />
          <div class="bar-info" :class="{isComplete: isProductsCompleted}">
            <h2 class="label">Products</h2>
            <span class="progress">{{ productsProgress }}%</span>
          </div>
        </li>

        <li class="bar">
          <ProgressBar :progress="ordersProgress" />
          <div class="bar-info" :class="{isComplete: isOrdersCompleted}">
            <h2 class="label">Orders <small>(Last 30 days)</small></h2>
            <span class="progress">{{ ordersProgress }}%</span>
          </div>
        </li>

        <li class="bar">
          <ProgressBar :progress="collectionsProgress" />
          <div class="bar-info" :class="{isComplete: isCollectionsCompleted}">
            <h2 class="label">Collections</h2>
            <span class="progress">{{ collectionsProgress }}%</span>
          </div>
        </li>
      </ul>

      <router-link v-if="completed" :to="{ name: 'Products' }" exact>
        <button class="welcome-btn">Get Started</button>
      </router-link>
      <button class="welcome-btn" v-else disabled>Get Started</button>

    </div>
    <div class="slider-wrap">
      <div class="slider-inner">
        <button class="flickity-prev" @click="previous()"><img src="../../assets/images/icon-arrow-left.svg" /></button>
        <button class="flickity-next" @click="next()"><img src="../../assets/images/icon-arrow-right.svg" /></button>
        <Flickity class="slider" ref="flickity" :options="flickityOptions">
          <div class="slide">
            <img class="slide-image" src="../../assets/images/preview.jpg" />
            <div class="slide-content">
              <h2 class="slide-title">Category Product Wall</h2>
              <p class="slide-body">Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Sed porttitor.</p>
            </div>
          </div>
          <div class="slide">
            <img class="slide-image" src="../../assets/images/preview.jpg" />
            <div class="slide-content">
              <h2 class="slide-title">Category Product Wall</h2>
              <p class="slide-body">Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Sed porttitor.</p>
            </div>
          </div>
          <div class="slide">
            <img class="slide-image" src="../../assets/images/preview.jpg" />
            <div class="slide-content">
              <h2 class="slide-title">Category Product Wall</h2>
              <p class="slide-body">Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Sed porttitor.</p>
            </div>
          </div>
        </Flickity>
      </div>
    </div>
  </main>
</template>

<script>
  import ProgressBar from '@/components/ProgressBar'
  import Flickity from 'vue-flickity'
  import 'flickity-imagesloaded'

  export default {
    name: 'welcome',
    components: {
      ProgressBar,
      Flickity
    },
    data () {
      return {
        collectionsTotal: 0,
        collectionsImported: 0,
        productsTotal: 0,
        productsImported: 0,
        ordersTotal: 0,
        ordersImported: 0,
        isProductsCompleted: false,
        isOrdersCompleted: false,
        isCollectionsCompleted: false,
        completed: false,
        isProUser: false,
        currentStep: 1,
        totalSteps: 2,
        flickityOptions: {
          prevNextButtons: false,
          pageDots: true,
          imagesLoaded: true,
          wrapAround: true,
          autoPlay: true
        }
      }
    },
    computed: {
      productsProgress: function () {
        return (this.productsTotal === 0 ? 0 : Math.min(100, this.productsImported / this.productsTotal * 100)).toFixed(0)
      },
      ordersProgress: function () {
        return (this.ordersTotal === 0 ? 0 : Math.min(100, this.ordersImported / this.ordersTotal * 100)).toFixed(0)
      },
      collectionsProgress: function () {
        return (this.collectionsTotal === 0 ? 0 : Math.min(100, this.collectionsImported / this.collectionsTotal * 100)).toFixed(0)
      }
    },
    mounted () {
      this.importProgress()
      this.interval = setInterval(() => { this.importProgress() }, 5000)
    },
    methods: {
      importProgress () {
        this.loadUser().then(() => {
          this.productsTotal = this.$shop.data.initial_import.products
          this.ordersTotal = this.$shop.data.initial_import.orders
          this.collectionsTotal = this.$shop.data.initial_import.smart_collections
          this.collectionsTotal += this.$shop.data.initial_import.custom_collections
          this.collectionsTotal += this.$shop.data.initial_import.collects

          this.productsImported = this.$shop.products_import
          this.ordersImported = this.$shop.orders_import
          this.collectionsImported = this.$shop.smart_collections_import
          this.collectionsImported += this.$shop.custom_collections_import
          this.collectionsImported += this.$shop.collects_import

          if (this.productsImported >= this.productsTotal) {
            this.isProductsCompleted = true
          }

          if (this.ordersImported >= this.ordersTotal) {
            this.isOrdersCompleted = true
          }

          if (this.collectionsImported >= this.collectionsTotal) {
            this.isCollectionsCompleted = true
          }

          if (this.$shop.initial_import) {
            this.completed = this.$shop.initial_import
            clearInterval(this.interval)
          }
        })
        .catch((error) => {
          console.log(error)
        })
      },
      next () {
        this.$refs.flickity.next()
      },
      previous () {
        this.$refs.flickity.previous()
      }
    }
  }
</script>

<style lang="scss" scoped>
  $green: #21CE99;

  .welcome {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    @media screen and (min-width: 1024px) {
      height: 100%;
      flex-direction: row;
      padding-bottom: 0;
    }
  }

  .welcome-btn {
    margin-top: 41px;
    display: flex;
    align-items: center;
    background-color: #21CE99;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Roboto Medium';
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    border-radius: 3px;
    height: 48px;
    display: inline-block;
    margin-right: auto;
    padding: 0 30px;
    &:hover {
      background-color: lighten(#21CE99, 5%);
    }
    &[disabled] {
      background-color: #525252;
      border-color: #525252;
      color: #888;
      box-shadow: none;
      pointer-events: none;
    }
  }

  .info,
  .slider {
    padding: 20px;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 768px) {
      padding: 40px;
    }

    @media screen and (min-width: 1024px) {
      padding: 90px 98px 0 ;
    }
  }

  .info {
    background-color: #262626;
    padding-bottom: 80px;
    flex: 0.5;
  }

  .slider {
    background-color: #383838;
    padding: 80px 40px;
    display: none;
    @media screen and (min-width: 1024px) {
      display: block;
      padding: 90px 40px 0;
    }

    &-inner {
      position: relative;
      margin: 0 10%;
      @media screen and (min-width: 1920px) {
        margin: 0 auto;
        max-width: 900px;
      }
    }
  }

  .slider-wrap {
    flex: 1;
    background: #383838;
    padding-bottom: 200px;
    position: relative;

    @media screen and (min-width: 1024px) {
      padding-bottom: 40vh;
    }
  }

  .slide {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .slide-content {
    max-width: 360px;
    margin: 0 auto;
  }

  .step {
    font-family: 'Roboto';
    font-size: 14px;
    color: #858585;
    letter-spacing: 0;
    line-height: 22px;
    margin-bottom: 84px;
  }

  .title {
    font-family: 'Roboto Bold';
    font-size: 45px;
    line-height: 1;
    margin-bottom: 18px;
    @media screen and (min-width: 768px) {
      font-size: 65px;
      line-height: 62px;
    }

    color: #FFFFFF;
    letter-spacing: 0;
  }

  .intro {
    font-family: 'Roboto';
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 41px;
    max-width: 420px;
    @media screen and (min-width: 1024px) {
      margin-bottom: 0;
    }
  }

  .bars {
    margin-top: 0;
    @media screen and (min-width:1024px) {
      margin-top: 41px;
    }
  }

  .bar {
    margin-bottom: 25px;
  }

  .bar-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 10px;
  }

  .label,
  .progress {
    display: block;
    font-family: 'Roboto Bold';
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 23px;
    transition: color 100ms ease;
  }

  .slide {
    margin-right: 20px;
    border-radius: 4px;
    &-title {
      font-family: 'Roboto Bold';
      font-size: 20px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 28px;
      margin-bottom: 5px;
      margin-top: 30px;
    }
    &-body {
      font-family: 'Roboto';
      font-size: 14px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 22px;
    }
    &-image {
      width: 100%;
      border-radius: 4px;

    }
  }

  .flickity-prev,
  .flickity-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 5;
    display: none;
    @media screen and (min-width: 1024px) {
      display: block;
    }
  }

  .flickity-prev {
    left: 0px;
  }
  .flickity-next {
    right: 0px;
  }

</style>

<style>
  .flickity-page-dots {
    left: 0;
  }

  @media screen and (min-width: 1024px) {
    .flickity-page-dots {
      bottom: -50px !important;
    }
  }

  .flickity-page-dots .dot {
    background: #fff !important;
    width: 8px !important;
    height: 8px !important;
  }
</style>


// WEBPACK FOOTER //
// src/js/pages/Welcome.vue